import { render, staticRenderFns } from "./Packing.vue?vue&type=template&id=726b7432&scoped=true"
import script from "./Packing.vue?vue&type=script&lang=ts"
export * from "./Packing.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726b7432",
  null
  
)

export default component.exports